<template>
  <div class="referrer-chain-tip" :class="`${referrerType}-referrer`">
    <div class="referrer-type-info">
      <span class="type-name">{{ $t(`${i18nKeyPrefix}.message.referralChainTip.${referrerType}.name`) }}</span>
      <span class="type-info">{{ $t(`${i18nKeyPrefix}.message.referralChainTip.${referrerType}.info`) }}</span>
    </div>
    <div class="chain-img"></div>
    <div class="chain-label">
      <div class="job">{{ $t(`${i18nKeyPrefix}.label.chainTip.job`) }}</div>
      <div class="referrer root-referrer">
        <div class="referrer-type">{{ $t(`${i18nKeyPrefix}.label.chainTip.root.line1`) }}</div>
        <div>{{ $t(`${i18nKeyPrefix}.label.chainTip.root.line2`) }}</div>
      </div>
      <div class="referrer middle-referrer">
        <div class="referrer-type">{{ $t(`${i18nKeyPrefix}.label.chainTip.middle.line1`) }}</div>
        <div>{{ $t(`${i18nKeyPrefix}.label.chainTip.middle.line2`) }}</div>
      </div>
      <div class="referrer direct-referrer">
        <div class="referrer-type">{{ $t(`${i18nKeyPrefix}.label.chainTip.direct.line1`) }}</div>
        <div>{{ $t(`${i18nKeyPrefix}.label.chainTip.direct.line2`) }}</div>
      </div>
      <div class="candidate">{{ $t(`${i18nKeyPrefix}.label.chainTip.candidate`) }}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    referrerType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      i18nKeyPrefix: 'admin.job.referral'
    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.referrer-chain-tip {
  width: 300px;
  background: #000;
  font-size: 12px;
  color: #b5b5b5;

  &.root-referrer {
    .chain-img {
      background-position: 0px -550px;
    }

    .chain-label {
      .root-referrer {
        color: #ff6633;
      }
    }
  }

  &.middle-referrer {
    .chain-img {
      background-position: 0px -450px;
    }

    .chain-label {
      .middle-referrer {
        color: #ff6633;
      }
    }
  }

  &.direct-referrer {
    .chain-img {
      background-position: 0px -500px;
    }

    .chain-label {
      .direct-referrer {
        color: #ff6633;
      }
    }
  }

  .referrer-type-info {
    .type-name {
      color: #ff6633;
    }

    .type-info {
      word-break: break-word;
    }
  }

  .chain-img {
    height: 32px;
    margin: 15px 0 5px;
    background: url($baseDomain + 'static/image/ReferralProgram_assets.png') no-repeat;
  }

  .chain-label {
    display: flex;
    justify-content: space-between;

    > * {
      width: 36px;
      text-align: center;
    }
  }
}

.page-en ~ div {
  .referrer-chain-tip {
    width: 325px;

    .chain-img {
      margin-left: 10px;
    }

    .chain-label {
      > * {
        width: 66px;
        white-space: nowrap;
      }

      .job {
        width: auto;
        margin: 0 22px 0 18px;
      }
    }
  }

}
</style>
